const KB = 1024;
const MB = KB * 1024;
const GB = MB * 1024;

export const formatByteSize = (size: number): string => {
  if (size === 0) {
    return "0 KB";
  }

  let unit: string;
  let base: number;

  if (size >= GB) {
    unit = " GB";
    base = GB;
  } else if (size >= MB) {
    unit = " MB";
    base = MB;
  } else {
    unit = " KB";
    base = KB;
  }

  const significand = size / base;
  let digits: number;
  if (significand >= 100) {
    digits = 0;
  } else if (significand >= 10) {
    digits = 1;
  } else {
    digits = 2;
  }

  return significand.toFixed(digits) + unit;
};
